import UI from "./base/UI";
import {setActivePosition, progressPosition} from "../functions/simple.ui";
import { isA11yCheckVersion } from "../functions/a11y.ui";

import Popup from "./base/Popup";

/**
 * Tab
 */

/**
#### HTML 구조 및 Data 속성 사용법
** [http://172.20.160.28:9700/kbank_html_mmk/components/component_tab.html](http://172.20.160.28:9700/kbank_html_mmk/components/component_tab.html)
*/
class Tab extends UI {
    defaults = {
        no: 0,
        tabArr: []
    };

    constructor(el, options) {
        super('tab', el);

        this.init(el, options);
    }

    chkIndex = 0;
    
    init(el, options) {
        if (options) {
            this.defaults = {...this.defaults, ...this.parseOptions(options)};
        }

        this.render();
    }
    /**
     * ui-tab 속성값 변경시 실행 
     * @example 
     * $('.ui-tab').data('ui').update();
     */
    update() {
        this.checkShowButton();
        this.setPosition();
    }

    render() {
        this.detachEvents();

        const $uiTabNav = this.$el.find('.ui-tab-nav > ul');

        $uiTabNav.attr({role: 'tablist'});
        $uiTabNav.find('li').attr({role: 'none'});
        $uiTabNav.find('li a').attr({role: 'tab'});

        this.attachCommonEvents();
        //this.setPosition();
        this.$window.trigger(`resize${this.eventId}`);
        if (this.$el.find('.ui-tab-nav li').length !== this.$el.find('.ui-tab-content').length && this.$el.attr('data-tab-content') == undefined) {
            let activeIndex = this.$el.find('.ui-tab-nav li.active').index();
            activeIndex = activeIndex === -1 ? 0 : activeIndex;
            this.a11y(activeIndex);
            return;
        }
        this.$el.find('.ui-tab-nav li').each((idx,el)=>{
            this.defaults.tabArr.push($(el).scrollTop())
        })
        this.attachStaticEvents();
        this.open(this.defaults.no);

    }
    

    setPosition(index = 0) {
        if (this.$el.find('.ui-tab-nav li.active').length <= 0) {
            this.$el.find('.ui-tab-nav li').eq(this.defaults.no).addClass('active');
        }
        if (this.$el.find('.ui-tab-nav').length > 0 ) {
            setActivePosition(this.$el.find('.ui-tab-nav'), this.$el.find('.ui-tab-nav li.active'));
        }
        //setActivePosition(this.$el.find('.ui-tab-nav'), this.$el.find('.ui-tab-nav li.active'));
        
    }

    attachStaticEvents() {
  
        function tooggleClassTarget(target, index){
            const targetAttr = target.attr('tab-addclass-target');
            if(targetAttr != undefined && targetAttr != ''){
                const addClassName = target.attr('tab-addclass-name'), addClassNum = target.attr('tab-addclass-num');
                (index == addClassNum) ? target.closest(targetAttr).addClass(addClassName) : target.closest(targetAttr).removeClass(addClassName);
            }
        }
        tooggleClassTarget(this.$el, this.chkIndex);
        
        let prevIndex = 0;
        this.$el.on(`click${this.eventId}`, '.ui-tab-nav a', (e) => {
            e.preventDefault();
            const $this = $(e.currentTarget);
            let beforeActiveIndex = this.$el.find('.ui-tab-nav li.active').index();
            const index = $this.closest('li').index();
            
           
            
            this.chkIndex = index;
            tooggleClassTarget($this.closest('.ui-tab'), this.chkIndex);
            if ($this.closest('.ui-tab').attr('data-type') == 'home') { // 240519  홈개편 발견탭 상담  active 중복 클릭 방지
                if (!$this.closest('li').hasClass('active')) {
                    if (this.defaults.flexScroll != undefined){
                        const beforeActive = $this.closest('.ui-tab-nav').find('.active');
                        this.defaults.tabArr[beforeActive.index()] = $('.page-inner-scroll').scrollTop();
                    }
                    this.open(index);
                }
            } else {
                if (this.defaults.flexScroll != undefined){
                    const beforeActive = $this.closest('.ui-tab-nav').find('.active');
                    this.defaults.tabArr[beforeActive.index()] = $('.page-inner-scroll').scrollTop();
                }
                this.open(index);
            }
            if (this.tabCallback && $.isFunction(this.tabCallback)) { // 240923 CHPFMTASK-870 tab callback 추가
                this.tabCallback(index);
            }
            // s : CHPFMTASK-1714 변경
            if (this.$el.hasClass('select-tab')) { // CHPFMTASK-1445 
                const $popupScrollEl = this.$el.closest('.popup-section').find('.popup-content')
                $popupScrollEl.attr(`tabScrTop${beforeActiveIndex}`, $popupScrollEl.scrollTop() )
                if ($popupScrollEl.attr(`tabScrTop${index}`) != undefined) {
                    // if ($(`[tab-content-id="${this.$el.attr('data-tab-content')}"]`).find('.ui-tab-content').eq(index).find('.btn-option.selected').length == 0) {
                    //     $popupScrollEl?.scrollTop(0)
                    // }else {
                    //     $popupScrollEl?.scrollTop($popupScrollEl.attr(`tabScrTop${index}`))
                    // }
                    $popupScrollEl?.scrollTop($popupScrollEl.attr(`tabScrTop${index}`))
                } else {
                    $popupScrollEl.scrollTop(0)
                }
            }
            // e : CHPFMTASK-1714 변경
            // CHPFMTASK-2264
            const tabContent = document.querySelectorAll(`[tab-content-id="tabCont1"] .ui-tab-content`)[0], sw = $(tabContent).find('.ui-swiper'); 
            if (index == 0 && prevIndex != index) {
                setTimeout(()=>{
                    if(sw.length > 0) {
                        for(let key in [...sw]){
                            if(sw.eq(key).data('ui').defaults.autoplay && sw.eq(key).data('ui').swiper.destroyed != true) sw.eq(key).data('ui').start();
                        }
                    }
                })
            }
            prevIndex = index;
        });

        // 240312 텝 변경 버튼 제어 추가
        const changeBtn = this.$el[0].querySelectorAll((`[data-chinge-tabcontent]`));
        changeBtn?.length && Array.from(changeBtn).forEach((el)=>{
            el.addEventListener(`click`,(e)=>{
                e.preventDefault();
                this.open(el.dataset.chingeTabcontent-1);
                $('.page-inner-scroll').stop().animate({scrollTop:0},0);
            });
        });
    }

    attachCommonEvents() {
        this.$el.on(`click${this.eventId}`, '.ui-tab-btn-expand', (e) => {
            e.preventDefault();
            const $this = $(e.currentTarget);

            this.$el.toggleClass('open');
            if (this.$el.hasClass('open')) {
                $this.find('.hide-txt').text('접기');

            } else {
                $this.find('.hide-txt').text('펼치기');
                this.setPosition();
            }
        });

        this.$window.on(`resize${this.eventId}`, (e) => {
            this.checkShowButton();
        });

        if(isA11yCheckVersion()){
            this.isA11yTabEvents();
        }
    }

    checkShowButton() {
        if (!this.$el.hasClass('open')) {
            if (this.$el.find('.ui-tab-nav').outerWidth() < this.$el.find('.tab-nav').width() + 50) {
                this.$el.find('.ui-tab-btn-expand').css('display', 'inline-flex');
            } else {
                this.$el.find('.ui-tab-btn-expand').css('display', 'none');
            }
        }
    }
    /**
     * tab open event
     * @param {Number} index
     * @example 
     * $('.ui-tab').data('ui').open();
     */
    open(index) {
        if (this.defaults.type == 'home') {  // 2024 홈개편
            let beforeActive = this.$el.find('.tab-list-col').attr('tab-idx') ==undefined ? 0 : Number(this.$el.find('.tab-list-col').attr('tab-idx'));
            
            if (index == 0) {
                this.$el.find('.ui-tab-nav li').eq(index).addClass('active').siblings().removeClass('active');
                $(`[tab-content-id="${this.$el.attr('data-tab-content')}"]`).find('.ui-tab-content').eq(index).show().siblings().hide()
                
                $('[home-tab-class]').addClass($('[home-tab-class]').attr('home-tab-class'))

                

            } else if (index == 1) {
                $('[home-tab-class]').removeClass($('[home-tab-class]').attr('home-tab-class'))
                this.$el.find('.ui-tab-nav li').eq(index).addClass('active').siblings().removeClass('active');
                $(`[tab-content-id="${this.$el.attr('data-tab-content')}"]`).find('.ui-tab-content').eq(index).show().siblings().hide()
                
                if ($('.homeTabBg').length < 1 && this.$el.closest('.main-tab-content02').length > 0) {
                    let rootHomeTabBGbefore = document.createElement("style");
                    rootHomeTabBGbefore.classList.add('homeTabBg')
                    rootHomeTabBGbefore.innerHTML = `[home-tab-class]:before{transition:opacity 0.3s}`;
                    this.$el.append(rootHomeTabBGbefore)
                }
                
            } else {
                $('[home-tab-class]').removeClass($('[home-tab-class]').attr('home-tab-class'))
                this.$el.find('.ui-tab-nav li').eq(index).addClass('active').siblings().removeClass('active');
                $(`[tab-content-id="${this.$el.attr('data-tab-content')}"]`).find('.ui-tab-content').eq(index).show().siblings().hide()
            }

            const dataInterestNumReset = $('.main-tab-content02').find('[data-interest-num][data-num-reset]'); // asis 홈 발견 탭 롤링
            // ------ s: tobe롤링  롤링 리셋 변수 ------ 
            const rollingNumReset = $('.main-tab-content02').find('.ui-rolling'); // tobe 홈 발견 탭 롤링
            // ------ e: tobe롤링  롤링 리셋 변수 ------ 
            if (index == 0) {
                if ($('.finding-credit-chart').length>0 && Number($('.finding-credit-chart .txt-count-wrap').attr('chart-offset')) < Number(this.$el.find('.tab-item').eq(0).attr('scrtop')) + $(window).height()) {
                    if (!$('.finding-credit-chart').hasClass('on') && $('.finding-credit-chart [data-id]').attr('svg-play') != 'true') {
                        frontUI.svgGraph({id:$('.finding-credit-chart [data-id]').attr('data-id')})
                        $('.finding-credit-chart').addClass('on')
                        dataInterestNumReset.each((i,e)=>{
                           frontUI.onRollingNumberReset()
                        })
                        frontUI.onRollingNumberStart($('.finding-credit-chart [data-interest-num]'))
                        $('.finding-credit-chart [data-interest-num]').closest('.txt-count-wrap').attr('num-reset', true);
                    }
                }
            } else {
                // ------ s: tobe롤링  탭 클릭 reset  ------ 
                if ($('.finding-credit-chart').length > 0) {
                    $('.finding-credit-chart').removeClass('on')
                    // 상세페이지 or 다른탭 이동했다가 돌아왔을때 그래프 재실행 되게끔 처리 25.01.17 (CHPFMTASK-1188)
                    $('.finding-credit-chart [data-id]').attr('svg-play', false);
                    frontUI.svgGraph({id:$('.finding-credit-chart [data-id]').attr('data-id'), reset: true})
                    dataInterestNumReset.each((i,e)=>{
                        $(e).closest('.txt-count-wrap').attr('num-reset', false);
                        frontUI.onRollingNumberReset()
                    })
                    rollingNumReset.each((i,e)=>{
                        $(e).closest('.ui-rolling-wrap').attr('data-action', false);
                        // 롤링되기전 숫자 안보이게끔 처리 2025.01.22 (CHPFMTASK-1188)
                        //  if($(e).attr('data-rolling-type') == undefined || !$(e).attr('data-rolling-type')) {
                        //     $(e).find('.rolling-box').css('opacity', '0');
                        //     console.log('tabjs opacity:0')
                        //  }
                         
                    })
                }
                // ------ e: tobe롤링  탭 클릭 reset  ------ 
            }
            
            if (this.$el.closest('.main-tab-content02').length > 0  || this.$el.closest('#mobile-web').length > 0) { // CHPFMTASK-1016  모바일 웹 수정
                let $content 
                if  (this.$el.closest('.main-tab-content02').length > 0 ) {   
                    $content = this.$el.closest('.main-tab-content02');
                } else {
                    $content = $('html')
                }
                this.$el.find('.tab-list-col').attr('tab-idx', index)
                const nowScrTop = $(this.$el.find('.active').eq(this.$el.find('.tab-list-col').attr('tab-idx')).prevObject[0]).attr('scrTop');
                if ($content.hasClass('scrolling')) {
                    if (nowScrTop == undefined){
                        $content.scrollTop(0)
                        this.$el.find('.tab-item.active').attr('scrtop', 0)
                    } else {
                        $content.scrollTop(nowScrTop)
                        this.$el.find('.tab-item.active').attr('scrtop', nowScrTop)
                    }
                } else {
                    if (nowScrTop == undefined || Number(nowScrTop) == 0) {
                        $content.scrollTop(0)
                        this.$el.find('.tab-item.active').attr('scrtop', 0)
                    } else {
                        $content.scrollTop(nowScrTop)
                        this.$el.find('.tab-item.active').attr('scrtop', nowScrTop)
                    }
                }
            }
        } else {
            if (this.$el.closest('#content_5') && this.$el.attr('data-tab-content') == 'investTab01') { // 240911 홈 - 투자탭 - 1depth 탭 상단고정
                $('#content_5').scrollTop(0)
            }
            
            if (this.$el.attr('data-tab-content') == undefined) {
                this.$el.find('.ui-tab-nav li')
                .eq(index).addClass('active')
                .siblings().removeClass('active');
                this.$el.find('.ui-tab-content')[0] && this.$el.find('.ui-tab-content')
                    .eq(index).show()
                    .siblings().hide();
            } else if (this.$el.closest('.component-main-bnf-tab').length > 0) { // 2024 홈개편
                this.$el.find('.ui-tab-nav li').eq(index).addClass('active').siblings().removeClass('active');
            } else if (this.$el.closest('.type-invest').length > 0) { // 2024  홈 투자탭 조건 추가
                this.$el.find('.ui-tab-nav li').eq(index).addClass('active').siblings().removeClass('active');
                $(`[tab-content-id="${this.$el.attr('data-tab-content')}"]`).find('> .ui-tab-content').eq(index).show().siblings().hide()
            } else {
                this.$el.find('.ui-tab-nav li').eq(index).addClass('active').siblings().removeClass('active');
                $(`[tab-content-id="${this.$el.attr('data-tab-content')}"]`).find('.ui-tab-content').eq(index).show().siblings().hide()    
                
            }
        }
        if (this.defaults.flexScroll != undefined){
            this.$el.closest('.page-inner-scroll').scrollTop(this.defaults.tabArr[index])
        }
        this.updateCallFn(index);
        this.setPosition(index);
        this.a11y(index);
        frontUI.aniDelay(this.$el.find('.ui-tab-content').eq(index)); // FETASK-1261 : 230810 추가
        $('.component-finding').on('touchstart click', function(){
            if ($(this).closest('[home-tab-class]').hasClass('fixed')) {
                $(this).closest('[home-tab-class]').removeClass('fixed')
            }
        })
        if(isA11yCheckVersion()){
            $('.tab-item a').attr('aria-selected','false');
            $('.tab-item.active a').attr('aria-selected','true');
            $('.tab-item.on a').attr('aria-selected','true');
        }
        this.chkIndex = index;
    }

    updateCallFn(index){
        // progress bar
        !!this.$el.find('.ui-tab-content').eq(index).find('.progress-content').length && progressPosition();

        // swiper
        if(!!this.$el.find('.ui-tab-content').eq(index).find('.ui-swiper').length){
            this.$el.find('.ui-tab-content').eq(index).find('.ui-swiper').each((i, swiper) => {
                if($(swiper).data('updated')) return false;
                $(swiper).data('ui').update();
                $(swiper).data('updated', true);
            })
        }
    }

    a11y(index) {
        this.$el.find('.ui-tab-nav li a')
            .attr({'aria-selected': false})
            .eq(index)
            .attr({'aria-selected': true});
        // .find('.hide-txt').remove().end()
        // .eq(index).find('a').prepend(`<span class="hide-txt">선택됨</span>`);
    }

    detachEvents() {
        this.$el.off(this.eventId);
        this.$window.off(this.eventId);
    }

    destroy() {
        this.detachEvents();
    }
    getScrollParent (node){
        if (node === null) return null; 
        const overflowY = window.getComputedStyle(node).overflowY;
        if (node.scrollHeight > node.clientHeight && overflowY !== 'visible' && overflowY !== 'hidden') {
            return node;
        } else if (node.tagName.toLowerCase() === 'body' ) {
            return window;
        } else {
            return this.getScrollParent(node.parentNode)
        }
    }
    /**
     * tab open callback
     * @param {Function} callback
     * @example 
     * $('.ui-tab').data('ui').callback(function(){});
     */
    callback(callback) { // 240923 CHPFMTASK-870 tab callback 추가
        this.tabCallback = callback;
    }
    isA11yTabEvents(){
        const tabItems = [...this.$el[0]?.querySelectorAll('.tab-item'), ...this.$el[0]?.querySelectorAll('.toggle-item')].filter((item) => !!item && item);

        tabItems && tabItems?.length && Array.from(tabItems)?.forEach((list,idx) => {
            const linkEle = list?.querySelector('a');

            const isCheckActive = !!list?.classList.contains('active');

            //linkEle && linkEle?.setAttribute('href','javascript:void();');

            list?.setAttribute('role','presentation none');

            //linkEle && linkEle?.setAttribute('aria-selected', isCheckActive); //active일때
            
            $(list).find('.tab-item a')?.attr('aria-selected','false');
            $(list).find('.tab-item.active > a')?.attr('aria-selected','true');
            $(list).find('.tab-item.on > a')?.attr('aria-selected','true');

            $(list).off(`click${this.eventId}`).on(`click${this.eventId}`, (e) => {
                e.preventDefault();

                $(document).find('.tab-item a')?.attr('aria-selected','false');
                $(document).find('.tab-item.active > a')?.attr('aria-selected','true');
                $(document).find('.tab-item.on > a')?.attr('aria-selected','true');

                //$('.ui-subTab')?.data('ui') && $('.ui-subTab')?.data('ui')?.init();

                Popup?.a11yDetctClosePopup();
            });
        });
    }
}

export default Tab;
